export const getCookie = (key, parse = false) => {
	if (!key) return;
	try {
		const cookie = document.cookie
			.split("; ")
			.find((row) => row.split("=")[0] === key);
		let cookieValue = cookie ? cookie.split("=")[1] : "";
		if (parse && cookieValue) {
			return JSON.parse(decodeURIComponent(cookieValue));
		}
		return cookieValue;
	} catch (error) {
		console.error(error);
	}
};

export const setCookie = (key, value, numberOfDays) => {
	if (!key) return;
	try {
		const expires = new Date();
		expires.setDate(expires.getDate() + numberOfDays);
		document.cookie = `${key}=${value}; expires=${expires.toUTCString()}; path=/`;
	} catch (error) {
		console.error(error);
	}
};

export const removeCookie = (key) => {
	if (!key) return;
	try {
		document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
	} catch (error) {
		console.error(error);
	}
};

const decodeCookieValue = (currentCookieValue) => {
	if (currentCookieValue) {
		try {
			const decodedCookieValue = JSON.parse(
				decodeURIComponent(currentCookieValue)
			);
			if (decodedCookieValue) {
				return decodedCookieValue;
			}
		} catch (error) {
			console.error(error);
		}
	}
	return null;
};

export const getCookieValue = (baseCookieValue, cookieNames = []) => {
	for (let index = 0; index < cookieNames.length; index++) {
		const cookieName = cookieNames[index];
		const currentCookieValue = decodeCookieValue(getCookie(cookieName));
		if (currentCookieValue) {
			return currentCookieValue;
		}
	}
	if (baseCookieValue) {
		return decodeCookieValue(baseCookieValue);
	}
	return null;
};

export const getConversationIdCookie = () => {
	return (
		getCookie("Conversation_UUID") ||
		getCookie("convId") ||
		getCookie("PHPSESSID")
	);
};

export const getGeolocationCookieData = (baseCookieValue, cookieNames) => {
	try {
		const geolocationCookieData = getCookieValue(baseCookieValue, cookieNames);
		const cookieData = {};
		if (geolocationCookieData) {
			const {
				region = "",
				country = "",
				metro = "",
				zipCode = "",
			} = geolocationCookieData;
			if (country) {
				cookieData["country"] = country
					.toLowerCase()
					.replace(/[+ ]/g, "_")
					.replace(/-/g, "");
			}
			if (region) {
				cookieData["region"] = region.toLowerCase();
			}
			if (metro) {
				cookieData["city"] = metro.toLowerCase();
			}
			if (zipCode) {
				cookieData["zipCodes"] = zipCode.replace(/-/g, "+").split("+");
			}
		}
		return cookieData;
	} catch (error) {
		console.error(error);
		return {};
	}
};
